import useBoostMultLockedVno from './useBoostMultLockedVno';

const useFarmAprs = () => {
  const { boostMultiplier, isLoading } = useBoostMultLockedVno();

  return {
    isLoading,
    boostMultiplier,
    isBoosted: !!boostMultiplier && boostMultiplier > 1,
  };
};

export const getMaxMultiplier = () => {
  // currently only VNO locking considered, no NFT stake
  // max here is 1.75
  return 1.75;
};

export default useFarmAprs;
